import styled from 'styled-components';
import { SkeletonBody } from "../Skeleton/styles";

export const CardTag = styled.article`
  border: 1px solid #f5f5f5;
  border-radius: 6px;
  overflow: hidden;
  
  @media(min-width: 700px) {
    display: flex;
  }
`;

export const CardImageContainer = styled.header`
  position: relative;
  
  height: 150px;
  
  ${SkeletonBody} {
    width: 100%;
    height: 100%;
  }
  
  @media(min-width: 700px) {
    width: 36%;
    flex-shrink: 0;
    height: 250px;
  }
  
  @media(min-width: 900px) {
    width: 35%;
    height: 250px;
  }
`;

export const CardInfo = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-grow: 1;
  padding: 15px 10px;
  
  @media(min-width: 700px) {
    padding: 30px 40px;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: nowrap;
  }
`;

export const CardHotelInfo = styled.div`
  width: 100%;
  margin-bottom: 10px;
  
  ${SkeletonBody} {
    width: 100%;
    height: 43px;
  }
  
  @media(min-width: 700px) {
    margin-bottom: 20px;
  
    ${SkeletonBody} {
      height: 40px;
    }
  }
  
  @media(min-width: 900px) {
    margin-bottom: 10px;
  
    ${SkeletonBody} {
      height: 20px;
    }
  }
`;

export const CardHeading = styled.h3`
  width: 100%;
  margin: 0;
  margin-bottom: 5px;
  
  ${SkeletonBody} {
    width: 100%;
    height: 21px;
  }
  
  @media(min-width: 700px) {
    margin-bottom: 15px;
  
    ${SkeletonBody} {
      height: 30px;
    }
  }
`;

export const CardDescription = styled.p`
  width: 100%;
  margin: 0;
  padding: 0;
  
  ${SkeletonBody} {
    width: 100%;
    height: 30px;
  }
  
  @media(min-width: 700px) {
    ${SkeletonBody} {
      height: 65px;
    }
  }
  
  @media(min-width: 900px) {
    ${SkeletonBody} {
      height: 45px;
    }
  }
`;


export const CardFooter = styled.footer`
  width: 100%;
  margin-top: 10px;
  
  ${SkeletonBody} {
    width: 100%;
    height: 24px;
  }
  
  @media(min-width: 700px) {
    margin-top: auto;
  }
`;
